import React, { useContext, useCallback } from 'react';
import ModalSentSuccessfully from 'components/ModalWindows/ModalSentSuccessfully';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import classNames from 'classnames';
import style from './ModalWindows.module.scss';
import { DishesContext, IDishesContext } from '../../dishesState/dishesContext';
import { ModalToConfirm } from 'components/ModalWindows/ModalToConfirm';
import CopyMenuModalState from './CopyMenuModal/copyMenuModalContext/copyMenuModalState/CopyMenuModalState';
import CopyMenuModal from './CopyMenuModal/CopyMenuModal';

const ModalWindows: React.FC = () => {
	const { deleteSelectedItem, changeTypeOfModalWindow, typeOfModalWindow } =
		useContext<IDishesContext>(DishesContext);
	const containerClasses = classNames(style.container, { [style.visible]: typeOfModalWindow });

	const handleChangeTypeOfModalWindow = useCallback(() => changeTypeOfModalWindow(null), [changeTypeOfModalWindow]);

	return (
		<div className={containerClasses} data-test="ModalWindows">
			<ModalToConfirm
				onConsentEvent={deleteSelectedItem}
				onFailureEvent={handleChangeTypeOfModalWindow}
				isVisible={typeOfModalWindow === 'toConfirmDeleteItem'}
				description="deleteDish"
				typeOfInfoIcon="toDelete"
			/>
			<ModalSentSuccessfully
				onConsentEvent={handleChangeTypeOfModalWindow}
				isVisible={typeOfModalWindow === 'success'}
				description="deleteDishSuccessfully"
			/>
			<ModalSentError
				onConsentEvent={handleChangeTypeOfModalWindow}
				isVisible={typeOfModalWindow === 'error'}
				description="errorWhileDeletingDish"
			/>
			<CopyMenuModalState>
				<CopyMenuModal
					changeTypeOfModalWindow={changeTypeOfModalWindow}
					isVisible={typeOfModalWindow === 'copyMenuModal'}
				/>
			</CopyMenuModalState>
		</div>
	);
};

export default ModalWindows;
